export function History() {
  return <h2>History</h2>;
}
